module.exports = __webpack_public_path__ + "static/media/guest-house-secondary.da168042.jpg";